<template>
  <div>
    <div class="bg">
      <div class="step">
        <el-steps :active="active" :align-center="true">
          <el-step
            @click.native="handleStep(item, index)"
            :title="item.name"
            v-for="(item, index) in stepList"
            :key="index"
          ></el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepsView',
  props: {
    active: {
      typeof: Number,
      default: () => 0
    },
    stepSlowStatus: {
      typeof: Number,
      default: () => 0
    },
    title: {
      typeof: String,
      default: () => ''
    },
    stepList: {
      typeof: Array,
      default: () => []
    }
  },
  methods: {
    handleStep(item, index) {
      this.$emit('handleItemTab', { item, index })
      //   this.$message.warning('上一步还未审核完成或发布，请继续进行审核')
    },
    async getFindStepNodeList(e) {
      console.log(e)
      // var res = await getFindStepNodeList()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.step {
  margin: 30px 220px;
  cursor: pointer;
}

::v-deep .el-step__head.is-finish,
::v-deep .el-step__title.is-finish {
  color: #c0c4cc;
  border-color: #c0c4cc;
}
::v-deep .el-step__title.is-process,
::v-deep .el-step__head.is-process {
  color: #72ad43;
  border-color: #72ad43 !important;
}
</style>
